


































import Vue from 'vue';
import RiskBox from '../../../common/components/ui/RiskBox/index.vue';
import settingsClient from '../../apis';
import commonVuex from '../../../common/vuex/common';

export default Vue.extend({
  mixins: [commonVuex],
  props: {
    topic: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showDeleteBox: false,
    };
  },
  computed: {
    itemLink(): string {
      return `https://${this.account.domain}.weixin.drip.im/wx-wap/crm?special=${this.account.domain}&vuePath=topic&id=${this.topic.id}`;
    },
    shortDesc(): string {
      return this.topic.longDesc.substring(0, 100).replace(/<\/?.+?>/g, '').replace(/ /g, '');
    },
  },
  methods: {
    deleteSubscribe() {
      settingsClient.deleteTopic({
        id: this.topic.id,
      }).success((r: any) => {
        this.$Message.success('删除成功');
        this.$emit('delete');
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
    onCopy() {
      this.$Message.success('复制成功');
    },
  },
  components: {
    RiskBox,
  },
});
